export const performerSteps = [
  { title: 'Build a profile that sounds like you', body: 'Photos, your Keys with samples, your fee and how far you’ll travel — Bangkok, Phuket or anywhere in between.' },
  { title: 'Swipe, browse or map nearby gigs', body: 'Every event shows a fit score and the reason it was suggested.' },
  { title: 'Match, chat, accept the offer', body: 'Payment is held by Encorza and lands in your bank or PromptPay 24 hours after you play.' },
];

export const organiserSteps = [
  { title: 'Post the event in two minutes', body: 'Date, budget, theme, crowd size — and as many acts as the night needs.' },
  { title: 'Swipe applicants or invite acts', body: 'Hear samples on the card. Right to match, left to pass.' },
  { title: 'Send an offer, fill the line-up', body: 'One protected payment per act by card or PromptPay. Slots fill as performers accept.' },
];

export const trustPoints = [
  { title: 'Protected payments', body: 'Organisers pay by card or PromptPay when an offer is accepted. We hold it and release it 24 hours after the gig.' },
  { title: 'Verified acts', body: 'ID, sample and past-gig checks before an act gets the verified badge.' },
  { title: 'Reviews both ways', body: 'After every gig, both sides review each other — reputations are earned, not bought.' },
];

export const plans = [
  {
    id: 'free',
    name: 'Free',
    price: '฿0',
    cadence: 'forever',
    audience: 'Everyone',
    features: ['Unlimited swiping and matching', 'Chat and booking offers', 'Post unlimited events', '10 applications a week for performers'],
    cta: 'Get started',
    to: '/start',
    highlight: false,
  },
  {
    id: 'pro',
    name: 'Performer Pro',
    price: '฿299',
    cadence: 'per month',
    audience: 'Singers & bands',
    features: ['See organisers who liked you', 'Unlimited applications', 'One profile boost every week', 'Views, saves and sample plays'],
    cta: 'Start as a performer',
    to: '/onboarding/performer',
    highlight: true,
  },
  {
    id: 'featured',
    name: 'Featured event',
    price: '฿490',
    cadence: 'per event',
    audience: 'Organisers',
    features: ['Top of matching performers’ feeds', 'Featured tag on cards and map pins', 'Lasts until your line-up is full', 'Around 3× more applicants'],
    cta: 'Start as an organiser',
    to: '/onboarding/organiser',
    highlight: false,
  },
];

export const faqs = [
  {
    q: 'Who pays the booking fee?',
    a: 'The organiser. It’s 6% of the agreed fee plus travel (minimum ฿150), charged only when a performer accepts an offer. Performers always receive their full quoted amount.',
  },
  {
    q: 'How do payments work?',
    a: 'Organisers pay by card or PromptPay. Encorza holds the money and pays the performer’s Thai bank account or PromptPay 24 hours after the gig, unless the organiser raises an issue.',
  },
  {
    q: 'What if an event is cancelled?',
    a: 'Cancel more than 14 days out and the organiser is refunded in full. Inside 14 days, the performer keeps 50% to cover lost bookings.',
  },
  {
    q: 'Can I book several acts for one event?',
    a: 'Yes. Add a slot for each act — singers, duos or bands — and each one is booked and paid separately.',
  },
];
